import { TermsCategory } from '@/api/terms.types';

export type EventRequiredTerms = Record<EventRequiredTermsType, boolean>;

export type EventRequiredTermsType =
  | TermsCategory.INFO_COLLECTION
  | TermsCategory.RECEIVE_MARKETING_INFO;

export const isEventRequiredTerms = (category: TermsCategory) => {
  return (
    category === TermsCategory.INFO_COLLECTION ||
    category === TermsCategory.RECEIVE_MARKETING_INFO
  );
};
